import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export const selector = '.global-header'

export default (
    el = null
) => {
    if (!el
            || document.body.classList.contains('.wp-admin'))
        return el

    console.groupCollapsed('Global Header')

    const hero = document
        .querySelector('.hero')

    const footer = document
        .querySelector('.global-footer')

    const scroll = ScrollTrigger.create({
        trigger: hero,
        start: 'bottom top', // The hero leaves the viewport
        endTrigger: footer,
        end: 'top bottom', // The footer enters the viewport
        scrub: true,
        onToggle: (self) => {
            const progress = self.progress

            if (progress && progress < 1) {
                el.classList.add('global-header-sticky-transform')

                setTimeout(() => {
                    el.classList.add('global-header-sticky')
                }, 100)

                setTimeout(() => {
                    el.classList.add('global-header-sticky-show')
                }, 200)
            }

            else {
                el.classList.remove('global-header-sticky-show')

                setTimeout(() => {
                    el.classList.remove('global-header-sticky')
                }, 100)

                setTimeout(() => {
                    el.classList.remove('global-header-sticky-transform')
                }, 200)
            }
        }
    })

    document.addEventListener('loadMoreEvent', () => {
        scroll.refresh()
    })

    console.log(el)

    console.groupEnd()

    return el
}
